import firebase from "firebase";

// Initialize Firebase
const config = {
   apiKey: "AIzaSyDTVf_w03NV5q_gMMenBCwBVydsVhYzCMk",
    authDomain: "med-ev-qa.firebaseapp.com",
    databaseURL: "https://med-ev-qa.firebaseio.com",
    projectId: "med-ev-qa",
    storageBucket: "med-ev-qa.appspot.com",
    messagingSenderId: "604891525886"
};

firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
